import { sameOriginPathname } from './returnUrl';

/**
 * Санитайзер `?returnTo=` для интра-appных возвратов (кнопка «Отмена»,
 * chain переходов createByAction/createOnBase, табы).
 *
 * Отличается от `sanitizeReturnUrl` тем, что не проверяет /login self-loop
 * и не работает с basePath — Front живёт в корне. Путь того же origin — по тем же правилам.
 */
export const sanitizeReturnTo = (raw: string | null | undefined): string | null => {
    if (typeof raw !== 'string' || raw === '') return null;
    return sameOriginPathname(raw) === null ? null : raw;
};

/**
 * Добавляет `?returnTo=<encoded>` к target URL, сохраняя существующий
 * query-string (делит через `?` или `&`).
 */
export const buildUrlWithReturnTo = (target: string, returnTo: string | null): string => {
    if (!returnTo) return target;
    const sep = target.includes('?') ? '&' : '?';
    return `${target}${sep}returnTo=${encodeURIComponent(returnTo)}`;
};

/**
 * Строит returnTo из текущего location. Корень (`/` или пусто) возвращает
 * `null` — нет смысла записывать "вернуться в корень".
 */
export const getCurrentAsReturnTo = (pathname: string, search: string, hash: string): string | null => {
    const from = `${pathname}${search}${hash}`;
    return from === '/' || from === '' ? null : from;
};
